<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/purposeful-features.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				Purposeful Features <br class="d-none d-sm-block" />
				Benefiting the Audited <br class="d-none d-sm-block" />
				and the Auditor
			</h1>
			<p class="shift-compliance-para mt-4">
				Shift your organization’s security and compliance
				<br class="d-none d-sm-block" />
				left with the most robust end-to-end compliance
				<br class="d-none d-sm-block" />
				solution on the market.
			</p>
		</div>
	</div>
</div>
